import { groupActions } from '../config/actions';

const defaultState = {
  isLoading: false,
  data: [],
  updated: false,
  currentGroup: null,
  error: null,
  message: null,
  pdf: null,
  lastCreated: null,
  join: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case groupActions.GROUP_IS_LOADING:
      return {
        ...state,
        isLoading: true,
        data: state.data || [],
        updated: false,
        currentGroup: state.currentGroup || null,
        error: null,
        pdf: state.pdf || null,
        lastCreated: null,
        join: null
      };
    case groupActions.GROUP_ERROR:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        updated: false,
        currentGroup: state.currentGroup || null,
        error: action.error,
        pdf: state.pdf || null,
        lastCreated: null,
        join: null
      };
    case groupActions.GROUP:
      return {
        ...state,
        isLoading: false,
        data: action.data,
        updated: false,
        currentGroup: state.currentGroup || null,
        error: null,
        pdf: state.pdf || null,
        lastCreated: action.lastCreated,
        join: null
      };
    case groupActions.GROUP_PDF:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        updated: false,
        currentGroup: state.currentGroup || null,
        error: null,
        pdf: action.pdf || null,
        lastCreated: null,
        join: null
      };
    case groupActions.SELECT_GROUP_RESET:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        updated: false,
        currentGroup: null,
        error: null,
        pdf: null,
        lastCreated: null,
        join: null
      };
    case groupActions.GROUP_RESET:
      return {
        ...state,
        isLoading: false,
        data: [],
        updated: false,
        currentGroup: null,
        error: null,
        pdf: null,
        lastCreated: null,
        join: null
      };
    case groupActions.GROUP_UPDATED:
      return {
        ...state,
        isLoading: false,
        data: action.data || [],
        updated: true,
        currentGroup: state.currentGroup || null,
        error: null,
        pdf: null,
        lastCreated: null,
        join: null
      };
    case groupActions.GROUP_JOIN:
      return {
        ...state,
        isLoading: false,
        data: state.data || [],
        updated: false,
        currentGroup: state.currentGroup || null,
        error: null,
        pdf: null,
        lastCreated: null,
        join: action.join || null
      };
    default:
      return state;
  }
};
